/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Validation_Name_RequiredInputs */

const en_branches_validation_name_required = /** @type {(inputs: Branches_Validation_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch name is required.`)
};

const pt_br2_branches_validation_name_required = /** @type {(inputs: Branches_Validation_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome da filial é obrigatório.`)
};

/**
* | output |
* | --- |
* | "Branch name is required." |
*
* @param {Branches_Validation_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_validation_name_required = /** @type {((inputs?: Branches_Validation_Name_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Validation_Name_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_validation_name_required(inputs)
	return pt_br2_branches_validation_name_required(inputs)
});